export default __webpack_public_path__ + "static/media/drresan.f4a75ced.jpeg";